import theme from "@/styles/theme";
import styled from "styled-components";

export const ContainerData = styled.div`
  font-family: "Gill Sans", "Gill Sans MT", Calibri, "Trebuchet MS", sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  width: 100%;
  height: 100%;
`;

export const FormUpdate = styled.form`
  display: flex;

  flex-direction: column;
  justify-content: center;
  align-items: center;

  border-radius: 10px;

  div {
    width: 100%;
  }
`;

export const DivTable = styled.div`
  background-color: #42372b;
  color: black;
  padding: 20px;
  width: 92%;
  border-radius: 3px;
`;

export const ModalContainer = styled.div`
  position: fixed;
  border-radius: 0.5rem;
  left: 50%;
  top: 50%;
  z-index: 60;

  width: 100%;
  max-width: 32rem;
  transform: translate(-50%, -50%);
  background-color: white;
  padding: 20px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05);
  transition: all 200ms ease-in-out;

  @media ${theme.devices.tablet} {
    width: 80%;
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 20px;
  font-weight: 600;
  font-size: 20px;

  div {
    display: flex;
    flex-direction: column;
    span {
      font-size: 12px;
      font-weight: 300;
      color: hsl(240 3.8% 46.1%);
    }
  }
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 50;
`;
